import reducer from "./reducers";

export { default as areasOperations } from "./operations";

export default reducer
